<h2 mat-dialog-title>New Support Request</h2>

@if (submissionState === 'idle') {
  <mat-dialog-content>
    <form [formGroup]="supportRequestForm" (ngSubmit)="onSubmit()">
      <div>
        <mat-form-field appearance="fill">
          <mat-label>Collector Name (Optional)</mat-label>
          <input
            class="input"
            type="text"
            #collector
            matInput
            [matAutocomplete]="collector_auto"
            formControlName="collector"
            [ngClass]="{ 'is-danger' : !supportRequestForm.get('collector').valid }"
            aria-label="Collector"
            >
          <mat-autocomplete #collector_auto="matAutocomplete" panelWidth="25%">
            @for (collector of filteredCollectors$ | async; track collector) {
              <mat-option [value]="collector.name">
                <img class="example-option-img" aria-hidden [src]="collector.icon" height="10">
                <span>{{ collector.name }}</span>
              </mat-option>
            }
          </mat-autocomplete>
          <mat-error [hidden]="supportRequestForm.get('collector').valid">
            Please choose an option from the list, or leave blank
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline">
          <mat-label>Details</mat-label>
          <textarea
            #content
            matInput
            formControlName="content"
            aria-label="Describe your request"
            rows="4"
            >
            Provide details here
          </textarea>
        </mat-form-field>
      </div>
      <div class="buttons-content">
        <button
          mat-flat-button
          color="accent"
          type="submit"
          [disabled]="supportRequestForm.invalid"
          >
          Submit
        </button>
        <button mat-button mat-dialog-close>
          Cancel
        </button>
      </div>
    </form>
  </mat-dialog-content>
}

@if (submissionState === 'success') {
  <mat-dialog-content>
    Thank you, your support request has been received.
  </mat-dialog-content>
}

@if (submissionState === 'error') {
  <mat-dialog-content>
    We're sorry, but your request could not be submitted.
    <br>
      Please email the request to <a href="mailto:support@rightbin.io">support&#64;rightbin.io</a> instead.
    </mat-dialog-content>
  }

  @if (submissionState !== 'idle') {
    <mat-dialog-actions>
      <div class="buttons-content">
        <button mat-flat-button mat-dialog-close color="accent">
          OK
        </button>
      </div>
    </mat-dialog-actions>
  }
